import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

export const devRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Dev", breadcrumbNavigate: false },
    async lazy() {
      const { RedoDevOnlyGuard } = await import("./redo-dev-only-guard");
      return { Component: RedoDevOnlyGuard };
    },
    children: [
      {
        path: "conversation-insights",
        handle: { breadcrumb: "Conversation Insights" },
        async lazy() {
          const { ConversationInsightsPage } =
            await import("../concierge/insights/conversation-insights-page");
          return { Component: ConversationInsightsPage };
        },
      },
      {
        path: "editor-testing",
        handle: { breadcrumb: "Faq Editor Testing" },
        async lazy() {
          const { EditorTestingPage } =
            await import("./editor-testing/editor-testing-page");
          return { Component: EditorTestingPage };
        },
      },
      {
        path: "client-side-tools",
        handle: { breadcrumb: "Client-Side Tools" },
        async lazy() {
          const { ClientSideToolsPage } =
            await import("./client-side-tools/client-side-tools-page");
          return { Component: ClientSideToolsPage };
        },
      },
      {
        path: "voice-v2",
        handle: { breadcrumb: "Voice v2" },
        async lazy() {
          const { VoiceV2Page } = await import("./voice-v2/voice-v2-page");
          return { Component: VoiceV2Page };
        },
      },
    ],
  },
];
